export const navigation = {
	allCategories: {
		label: "Toutes les catégories",
	},
	header: {
		title: "Catégories",
		searchTooltip: "Rechercher des catégories",
		addCategoryTooltip: "Ajouter une catégorie",
		showZeroProductCategoriesTooltip: "Afficher les catégories sans produits",
		hideZeroProductCategoriesTooltip: "Masquer les catégories sans produits",
		showEmptyCategories: "Afficher les catégories sans produits",
		hideEmptyCategories: "Masquer les catégories sans produits",
		show: "Afficher",
		hide: "Masquer",
	},
	search: {
		placeholder: "Rechercher une catégorie",
		closeTooltip: "Fermer la recherche",
	},
	subcategories: {
		levelPrefix: "Niveau",
	},
	priorityLabel: "Niveau",
	categoryDisabledTooltip: "Impossible d'ajouter des produits à cette catégorie",
	loadingCategories: "Chargement des catégories",
	emptyState: {
		noSearchResults: {
			title: "Aucune catégorie trouvée",
			message:
				"Nous n'avons pas trouvé de catégories qui correspondent à votre recherche de",
		},
		noCategories: {
			title: "Aucune catégorie trouvée",
			message:
				"Vous n'avez pas encore de catégories de produits. Créez votre première catégorie pour organiser vos produits.",
		},
		noCategoriesWithFilters: {
			title: "Les catégories sont masquées",
			message:
				"Aucune catégorie ne correspond à vos filtres actuels. Cliquez pour afficher toutes les catégories ou supprimez les filtres.",
		},
		clearSearchButton: "Effacer la recherche",
		createCategoryButton: "Créer une catégorie",
		showHiddenCategoriesButton: "Afficher les catégories",
	},
};
